import { auth } from "./firebase";
import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  sendEmailVerification,
  signInWithPopup,
  signInWithEmailAndPassword,
  OAuthProvider,
} from "firebase/auth";
import { useDispatch, useSelector } from "react-redux";
import { doc, getDoc, setDoc, onSnapshot } from "firebase/firestore";
import { db } from "../../components/Firebase/firebase";
import { logOut } from "../../app/features/authSlice";
import { useEffect } from "react";
import { signOut } from "firebase/auth";
import { handleMultiDeviceLogin, handleMultiDeviceLogout, validateDeviceSession, migrateLegacySession } from "../../services/multiDeviceAuth";
import { getDeviceId } from "../../utils/deviceManager";

export const doCreateUserWithEmailAndPassword = async (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};
export const doSignInWithEmailAndPassword = async (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const doSignInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  return result;
};
export const handleMicrosoftLogin = async () => {
  const provider = new OAuthProvider("microsoft.com");
  try {
    const result = await signInWithPopup(auth, provider);
    return result;
  } catch (error) {
    console.error("Error during Microsoft Login:", error.message);
  }
};
const AUTO_LOGOUT_TIME = 8 * 60 * 60 * 1000;

export const useAutoLogout = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const loginTime = localStorage.getItem("goalfyloginTimestamp");
    const currentTime = Date.now();

    if (loginTime && currentTime - parseInt(loginTime) > AUTO_LOGOUT_TIME) {
      signOut(auth);
      localStorage.removeItem("goalfyloginTimestamp");
      window.location.reload();
    }

    const interval = setInterval(() => {
      const updatedTime = localStorage.getItem("goalfyloginTimestamp");
      if (
        updatedTime &&
        Date.now() - parseInt(updatedTime) > AUTO_LOGOUT_TIME
      ) {
        signOut(auth);
        localStorage.removeItem("goalfyloginTimestamp");
        dispatch(logOut());
      }
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, []);
};

export const useSessionCheck = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // [PARALLEL-WORLD] Firestore-based multi-device session check disabled (parallel project has no Firestore).
    return;
    // eslint-disable-next-line no-unreachable
    const user = auth.currentUser;
    if (!user) return;

    let unsubscribeSnapshot;

    const initRealtimeSessionCheck = async () => {
      try {
        // Migrate legacy session if needed
        await migrateLegacySession(user.uid);

        const currentDeviceId = getDeviceId();
        if (!currentDeviceId) {
          await signOut(auth);
          dispatch(logOut());
          return;
        }

        const userDocRef = doc(db, "users", user.uid);
        unsubscribeSnapshot = onSnapshot(
          userDocRef,
          (snapshot) => {
            if (!snapshot.exists()) {
              signOut(auth);
              dispatch(logOut());
              return;
            }
            const data = snapshot.data();
            const sessionIds = Array.isArray(data.sessionIds) ? data.sessionIds : [];
            if (!sessionIds.includes(currentDeviceId)) {
              signOut(auth);
              dispatch(logOut());
            }
          },
          (error) => {
            console.error("Session snapshot error:", error);
            signOut(auth);
            dispatch(logOut());
          }
        );
      } catch (error) {
        console.error("Session check init error:", error);
        await signOut(auth);
        dispatch(logOut());
      }
    };

    initRealtimeSessionCheck();

    return () => {
      if (typeof unsubscribeSnapshot === "function") {
        unsubscribeSnapshot();
      }
    };
  }, []);
};
export const doSignOut = async (userId) => {
  if (userId) {
    await handleMultiDeviceLogout(userId);
  } else {
    await signOut(auth);
  }
};
// export const doPasswordReset = (email) => {
//   return auth.sendPasswordResstEmail(auth, email);
// };
// export const doPasswordChange = (password) => {
//   return auth.updatePassword(auth.currentUser, password);
// };
// export const doSendEmailVerification = () => {
//   return sendEmailVerification(auth.currentUser, {
//     url: `${window.location.origin}/home`,
//   });
// };
